import { useContext } from 'react';
import { F as FormIdContext } from '../contexts/FormId/FormIdContext-BvlItbMu.js';

const useFormId = () => {
  const formId = useContext(FormIdContext);
  return formId;
};

export { useFormId as u };
//# sourceMappingURL=useFormId-Cc85-a5p.js.map
